import gql from 'graphql-tag';

export const POSTS_BY_USER = gql`
    query postsByUser($preferredUsername: String!, $limit: Int, $skip: Int) {
        posts: postsByUser(
            preferredUsername: $preferredUsername
            limit: $limit
            skip: $skip
        ) {
            postId
            title
            slug
            modifiedAt
            authors {
                preferredUsername
                displayName
            }
            image {
                sourceUrl
            }
            categories {
                name
                slug
            }
        }
    }
`;

export const POSTS_ABOUT_USER = gql`
    query postsAboutUser($preferredUsername: String!, $limit: Int, $skip: Int) {
        posts: postsAboutUser(
            preferredUsername: $preferredUsername
            limit: $limit
            skip: $skip
        ) {
            postId
            title
            slug
            modifiedAt
            authors {
                userId
                preferredUsername
            }
            image {
                sourceUrl
            }
            categories {
                name
                slug
            }
        }
    }
`;
